'use client';

import { c as _c } from "react/compiler-runtime";
import { AdditionalSettingsFormDynamic, BlockProps, ComponentBaseProps, FormDynamicVariantEnum } from '@sola/schema/lib/schema.ts';
import { submitLeadChurchForm, submitLeadEventForm, submitSubscription } from '@sola/skippy-sdk/requests.ts';
import { EventForm } from '../../../organisms/forms/event-form/event-form.tsx';
import { FormEmailSubscribe } from '../../../organisms/forms/form-email-subscribe/form-email-subscribe.tsx';
import { LeadForm } from '../../../organisms/forms/lead-form/lead-form.tsx';
export type FormDynamicCoreProps = BlockProps & ComponentBaseProps;
export const FormDynamicCore = t0 => {
  const $ = _c(12);
  const {
    settings
  } = t0;
  let t1;
  if ($[0] !== settings) {
    t1 = settings ? AdditionalSettingsFormDynamic.parse(settings) : undefined;
    $[0] = settings;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formDynamicSettings = t1;
  if (!formDynamicSettings) {
    return;
  }
  let t2;
  if ($[2] !== formDynamicSettings) {
    t2 = formDynamicSettings.formType === FormDynamicVariantEnum.enum.subscription && <FormEmailSubscribe subscriptionCode={formDynamicSettings.subscriptionCode || "Leads_General_Sign_Up"} onSubmit={submitSubscription} config={formDynamicSettings} isFirstNameRequired={true} isLastNameRequired={true} />;
    $[2] = formDynamicSettings;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== formDynamicSettings) {
    t3 = formDynamicSettings.formType === FormDynamicVariantEnum.enum.lead && <LeadForm onSubmit={submitLeadChurchForm(formDynamicSettings.leadType || "contactme", formDynamicSettings.subscriptionCode || "Leads_General_Sign_Up")} config={formDynamicSettings} />;
    $[4] = formDynamicSettings;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== formDynamicSettings) {
    t4 = formDynamicSettings.formType === FormDynamicVariantEnum.enum.event && <EventForm onSubmit={submitLeadEventForm(formDynamicSettings.leadType || "registration")} config={formDynamicSettings} />;
    $[6] = formDynamicSettings;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <section className="component component--no-header"><div className="container">{t2}{t3}{t4}</div></section>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};